import { Routes, Route } from "react-router-dom";
import Login from "./Component/Login";
import DashboardLayout from "./Component/Home";
import NotificationPanel from "./Component/Notification";
import StudentTable from "./Component/StudentManagment";
import AddStudent from "./Component/studentForm";
import StudentProfile from "./Component/StudentView";
import StudentProfileEdit from "./Component/StudentEdit";
import Setting from "./Component/Setting";
import TeacherEdit from "./Component/TeacherEdit";
import ExamManagement from "./Component/ExamManagment";
import ExamView from "./Component/ExamView";
import ExamEdit from "./Component/ExamEdit"
import PublishPaper from "./Component/PublishPaper";
import CreateExam from "./Component/CreateExamForm";
import AddQuestion from "./Component/AddQuestion";
import PreviewPaper from "./Component/PreviewPaper";
import ResultTabel from "./Component/ResultTabel";
import ResultReview from "./Component/ResultView";
import ExamList from './Component/ByDefault';
import ExamPreview from "./Component/DefaultPaper";
import AutoGenerate from "./Component/AutoGenerate";
import StudentResult from "./Component/StudentResult";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<StudentTable />} />
        <Route path="studentmanagment" element={<StudentTable />} />
        <Route path="studentform" element={<AddStudent />} />
        <Route path="studentview/:id" element={<StudentProfile />} />
        <Route path='studentresult/:id' element={<StudentResult/>}/>
        <Route path="studentedit/:id" element={<StudentProfileEdit />} />

        <Route path="exammanagment" element={<ExamManagement />} />
        <Route path="examview/:id" element={<ExamView />} />
        <Route path="examedit/:id" element={<ExamEdit />} />
        <Route path="createexam" element={<CreateExam />} />
        <Route path="auto-generate/:paperId/:softwareId" element={<AutoGenerate />} />
        <Route path="addquestion/:id" element={<AddQuestion />} />
        <Route path="previewpaper/:id" element={<PreviewPaper />} />
        <Route path="/dashboard/bydefault/:softwareId/:standardId" element={<ExamList />} />
        <Route path="/dashboard/exampreveiw/:paperId" element={<ExamPreview />} />

        <Route path="resulttabel" element={<ResultTabel />} />
        <Route path="resultview" element={<ResultReview />} />

        <Route path="publishpaper" element={<PublishPaper />} />


        <Route path="settings" element={<Setting />} />
        <Route path="teacheredit" element={<TeacherEdit />} />

        <Route path="notification" element={<NotificationPanel />} />
      </Route>
    </Routes>
  );
}

export default App;
